import React, { useState } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';
import Logo from '../components/Logo';

const API = process.env.REACT_APP_BACKEND_URL;

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get('token') || '';
  const [pw, setPw] = useState('');
  const [pw2, setPw2] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (pw.length < 8) { setError('Passordet må være minst 8 tegn'); return; }
    if (pw !== pw2) { setError('Passordene er ikke like'); return; }
    setLoading(true);
    try {
      await axios.post(`${API}/api/auth/reset-password`, { token, new_password: pw });
      toast.success('Passordet er oppdatert. Logg inn med det nye passordet.');
      navigate('/login');
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === 'string' ? detail : 'Noe gikk galt.');
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center p-4">
        <div className="w-full max-w-sm bg-card border border-border rounded-md p-6">
          <h1 className="font-heading text-xl font-bold mb-2">Ugyldig lenke</h1>
          <p className="text-sm text-muted-foreground mb-4">Tilbakestillingslenken mangler en token.</p>
          <Button asChild variant="outline" className="w-full">
            <Link to="/forgot-password">Be om ny lenke</Link>
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4" data-testid="reset-password-page">
      <div className="w-full max-w-sm">
        <Link to="/" className="flex items-center gap-2 mb-8 hover:opacity-80">
          <Logo variant="full" height={40} />
        </Link>
        <div className="bg-card border border-border rounded-md p-6">
          <h1 className="font-heading text-2xl font-bold mb-2">Lag nytt passord</h1>
          <p className="text-sm text-muted-foreground mb-4">Velg et nytt passord på minst 8 tegn.</p>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <Label htmlFor="pw">Nytt passord</Label>
              <Input
                id="pw" type="password" value={pw}
                onChange={(e) => setPw(e.target.value)} required
                data-testid="reset-pw-input"
              />
            </div>
            <div>
              <Label htmlFor="pw2">Bekreft passord</Label>
              <Input
                id="pw2" type="password" value={pw2}
                onChange={(e) => setPw2(e.target.value)} required
                data-testid="reset-pw2-input"
              />
            </div>
            {error && <p className="text-sm text-destructive" data-testid="reset-error">{error}</p>}
            <Button type="submit" className="w-full" disabled={loading} data-testid="reset-submit-button">
              {loading ? 'Lagrer...' : 'Lagre nytt passord'}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
